import axios from 'axios'
import { ExternalTaxRatesInterface } from 'client/Interfaces/ExternalVATRatesInterface'
import isEmpty from 'lodash/isEmpty'
import mapValues from 'lodash/mapValues'
import sortBy from 'lodash/sortBy'

import { Segment } from '../Global/Segment'
import { SegmentEvents } from '../Global/SegmentEvents'
import { getRequestConfig } from './index'

interface AccountingRedirectUrlRes {
  redirectUrl: string
}

export async function getAccountingRedirectUrl(): Promise<AccountingRedirectUrlRes> {
  const res = await axios.get('/platform/v4/billy-redirect-url', getRequestConfig())
  return res.data
}

export const getExternalVATRates = async (): Promise<ExternalTaxRatesInterface | null> => {
  try {
    const res = await axios.get('/platform/v4/company/external-vat-rates', {
      ...getRequestConfig(),
      transformResponse: (data) => {
        const parsedData = JSON.parse(data)
        return mapValues(parsedData, (values) => sortBy(values, 'priority'))
      },
    })

    if (!res || isEmpty(res.data)) {
      Segment.track(SegmentEvents.accounting.externalVatRatesMissing, {
        reason: 'No data returned.',
      })
    }

    return res.data
  } catch (error) {
    Segment.track(SegmentEvents.accounting.externalVatRatesMissing, {
      reason: 'External Vat rate endpoint error',
    })

    return null
  }
}
